/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Typography, Grid, Button } from '@mui/material';
import { Badge } from '../Badge/Badge';

const style = {
  bgcolor: 'rgba(144, 202, 249, 0.1)',
  boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;',
  borderRadius: '5px',
  fullWidth: '100%',
  justifyContent: 'center',
  alignItems: 'center',
};

const btnStyle = {
  bgcolor: 'rgba(144, 202, 249, 0.15)',
  color: '#FFF',
  borderRadius: '0 0 5px 5px',
  boxShadow: 'none !important',
};

export const ProjectCard = (props) => {
  return (
    <Grid item xs={6} sm={6} md={4}>
      <Grid container direction="column" sx={style}>
        <Grid
          item
          sx={{ my: 2, py: 1, px: 5, textAlign: 'justify', width: '100%' }}
        >
          <Typography
            sx={{ lineHeight: '1', fontWeight: 500, mb: 2 }}
            margin={0}
            variant="subtitle1"
            align="center"
          >
            {props.title}
          </Typography>
          <Typography variant="caption">{props.desc}</Typography>
          <Grid
            container
            spacing={2}
            sx={{ mt: 1, display: 'flex', flexDirection: 'row' }}
          >
            <Grid item xs={6}>
              <Badge bgcolor={props.activeColor} title={props.active} />
            </Grid>
            <Grid item xs={6}>
              <Badge bgcolor={'#84D8C5'} title={`${props.hours} HRS`} />
            </Grid>
          </Grid>
        </Grid>
        <Button fullWidth sx={btnStyle} onClick={props.onClick}>
          View
        </Button>
      </Grid>
    </Grid>
  );
};
